<template>
  <v-app>
    <AppBar @toggle="drawerToggle=!drawerToggle" />
    <v-navigation-drawer v-if="showDrawer" v-model="drawerToggle" app clipped>
      <NavDrawer />
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import "@/firebase/init";
import AppBar from "@/components/Navigation/AppBar";
import NavDrawer from "@/components/Navigation/NavDrawer";
export default {
  name: "App",
  components: { AppBar, NavDrawer },
  data: () => ({
    drawerToggle: null,
    showDrawer: null,
  }),
  methods: {
    updateDrawer(route) {
      let meta = route.meta;
      this.showDrawer = meta == null ? true : !meta.isForLogin;
    },
  },
  created() {
    this.updateDrawer(this.$router.currentRoute);
  },
  watch: {
    $route(to) {
      this.updateDrawer(to);
    },
  },
};
</script>
